module.exports = "/_next/static/images/AggregationIdentityResolution@2x-60aae68dfcce7d456d09312d6e90164f.png";